import { defineStore } from "pinia";
import YearsApi from "../api/Api/YearsApi";
import { flattenDeep } from "lodash";
import { yearLabel } from "../utils/helpers";
import { ref, computed, watch } from "vue";
import { useAdminStore } from "./adminStore";
import { useUserStore } from "./user";
export const isSetupBusy = ref(false);

export const useYearStore = defineStore("year", () => {
  const years = ref([]);
  const year = ref({
    sportCode: "MTE",
    division: 1,
  });

  watch(year, (year, oldYear) => {
    const adminStore = useAdminStore();
    if (!year || year.id === adminStore.adminYear.id) return;
    adminStore.$reset();
    adminStore.fetchAdminYear(year.id);
    // when year changes , fetch admin data and school submission list
  });
  const yearOptions = computed(() => {
    const distinctYears = [
      ...new Set(flattenDeep(years.value.map((x) => x.academicYear))),
    ];
    return distinctYears.map((year) => {
      return { value: year, text: yearLabel(year) };
    });
  });

  const currentYearPresent = computed(() => {
    return (
      years.value &&
      years.value.length > 0 &&
      years.value[0].academicYear === new Date().getFullYear()
    );
  });

  async function createYear() {
    isSetupBusy.value = true;
    return YearsApi.new()
      .then(() => fetchYears(false))
      .finally(() => (isSetupBusy.value = false));
  }

  async function fetchYears(setCurrentYear = true) {
    return YearsApi.list().then((response) => {
      years.value = response;
      if (setCurrentYear) setCurrentYearAfterFetchingList(years);
      return years.value[0].academicYear;
    });
  }

  function setCurrentYearAfterFetchingList(years) {
    // set current acad year equal to the max acad year from the list
    const userStore = useUserStore();
    const adminStore = useAdminStore();
    if (!userStore.isStaff) {
      year.value = years.value[0];
      adminStore.fetchAdminYear(year.value.id);
      return;
    }
    const currentYear = years.value.find(
      (currYear) =>
        currYear.sportCode === year.value.sportCode &&
        currYear.division === year.value.division
    );
    if (currentYear) {
      year.value.academicYear = currentYear.academicYear;
      year.value.id = currentYear.id;
      adminStore.fetchAdminYear(currentYear.id);
    }
  }

  function setYear(academicYear) {
    if (academicYear) {
      year.value = years.value.find(
        (currYear) =>
          currYear.sportCode === year.value.sportCode &&
          currYear.academicYear === academicYear &&
          currYear.division === year.value.division
      );
    }
  }

  function setYearObject(yearObj) {
    year.value = yearObj;
  }

  function setSportCodeAndDivision(sportCode, division, academicYear) {
    if (sportCode && division) {
      year.value = years.value.find(
        (currYear) =>
          currYear.sportCode === sportCode &&
          currYear.academicYear === (academicYear || year.value.academicYear) &&
          currYear.division === division
      );
    }
  }

  function setYearById(yearId) {
    year.value = years.value.find((year) => year.id === yearId);
  }

  return {
    year,
    years,
    yearOptions,
    currentYearPresent,
    createYear,
    fetchYears,
    isSetupBusy,
    setYear,
    setYearObject,
    setSportCodeAndDivision,
    setYearById,
  };
});
